import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { RouteI } from 'safe'

import '../../assets/css/components/MenuList.css'
import { TabContext } from '../../context/TabContext'
import { RootState } from '../../redux/store'
import Tooltip from '../Display/Tooltip'
import uniqueId from 'lodash/uniqueId'


/**
 * Componente que representa el redirect y los submenus de la aplicacion.
 * @param {RouteI[]} routes rutas pertenecientes al archivo
 * routes.ts
 * @param {String} basePath Ruta base para realizar el redireccionamiento.
 * @param {number} urlIndex Index que se selecciona.
 */
const SubMenu: React.FC<SubMenuProps> = ({
  routes,
  basePath,
  urlIndex = 0,
}) => {
  const [selected, setSelected] = useState<number>(-1)
  const history = useHistory()

  const userRole = useSelector((state: RootState) => state?.auth?.user)

  const { onClick } = useContext(TabContext)

  useEffect(() => {
    let route = history.location.pathname.split('/')
    setSelected(routes.findIndex((r) => r.path === route[1 + urlIndex]))
    return history.listen((location) => {
      route = location.pathname.split('/')
      setSelected(routes.findIndex((r) => r.path === route[1 + urlIndex]))
    })
  }, [history, routes, urlIndex])

  return (
    <div
      className={`lg:mx-10 mx-5 flex flex-row flex-wrap bg-gray-100 dark:bg-primaryGray-dark`}
    >
      {routes.map(({ title, icon: Icon, path, disabled }, i) => (
        <Tooltip
          // key={0}
          title={disabled ? userRole['custom:user_plan'] === 'emprendedor' ? `Suscríbete al Plan PYME para acceder a esta función` : '' : ''}
          position="top"
          xOffset={0}
          yOffset={0}
          show={true}
          classes="flex-grow"
        >
        <Link
          key={i}
          to={disabled ? '' : `${basePath}/${path}` }
          className="flex-grow"
          style={{ overflow: 'hidden', borderRadius: '5px', pointerEvents: disabled ? "none" : 'auto' }}
          /** Lógica solo para que en ventas al darle nuevamente al tab}
           * se reinicen algunos estados.
           */
          onClick={() => {
            const randomId = uniqueId()

            // console.log("presionando...")
            onClick(randomId)
          }}
        >
            <div
              className={`px-3 transition-all py-2.5 flex items-center justify-center cursor-pointer ${
                i === selected
                  ? 'bg-primaryGray-200 dark:bg-black'
                  : 'dark:bg-primaryGray bg-primaryGray-100'
              } ${disabled && 'opacity-25'}`}
              onClick={() => !disabled && setSelected(i)}
            >
              <div className={`h-full flex items-center`}>
                <span className="text-center">
                  {/* <Icon
                  className={`${
                    i === selected
                      ? 'text-primary dark:text-white'
                      : 'text-trueGray-600 dark:text-gray-300'
                  } mr-3 z-20 text-lg`}
                /> */}
                </span>
                <p className={`text-dark dark:text-white`}>
                  <b>{title}</b>
                </p>
              </div>
            </div>
        </Link>
          </Tooltip>
      ))}
    </div>
  )
}

export default SubMenu

interface SubMenuProps {
  routes: RouteI[]
  basePath: string
  urlIndex?: number
}
